import { CardsContainer } from "components/Cards";
import { useStoryblokLink } from "hooks";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { CardsBlokProps } from "./Cards.d";

const CardsAdapter = ({ blok: { cards, cardsHeightDesktop, cardsUrl } }: ReactStoryblokComponent<CardsBlokProps>) => {
  const url = useStoryblokLink(cardsUrl);

  return <CardsContainer cards={cards} cardsHeightDesktop={cardsHeightDesktop} cardsUrl={url} />;
};

export default CardsAdapter;
